mutation AgentConfirmUpload($input: ConfirmUploadInput!) {
  confirmUpload(input: $input) {
    id
    originalFilename
    mimeType
    size
    status
  }
}
